<template>
    <div>
        <slot v-if="renderNavbar" name="navbar">
            <app-navbar :active.sync="showJoinModal" />
        </slot>
        <div class="section is-paddingless">
            <div class="is-marginless" :class="renderNavbar ? 'lb-main-layout' : 'lb-full-layout'">
                <div
                    v-if="$mq != 'mobile'"
                    class="lb-menu has-background-pale-grey"
                >
                    <slot name="side-menu" />
                </div>
                <div class="lb-content">
                    <slot name="main-content" />
                </div>
            </div>
        </div>
        <session-join-modal
            v-if="showJoinModal"
            @close="showJoinModal = false"
            @join="navigateToSession"
        />
    </div>
</template>

<script>
import AppNavbar from '@/components/AppNavbar';
import SessionJoinModal from '@/components/SessionJoinModal';
export default {
    components: {
        AppNavbar,
        SessionJoinModal,
    },
    data() {
        return {
            showJoinModal: false,
        };
    },
    methods: {
        navigateToSession({ code }) {
            this.$router.push({ name: 'play', query: { code } });
        },
    },
    props: {
        renderNavbar: {
            type: Boolean,
            default: true,
        },
    },
};
</script>

<style scoped>
.lb-content {
    overflow-y: scroll;
    height: 100%;
}
</style>
